import React from "react";
import "./_styles.scss";

interface HeadingProps {
  name: string;
}

export default function Heading({ name }: HeadingProps) {
  return <h1>{name}</h1>;
}
